import { https } from "../http";
import store from "../store";
import {
  setAddbillingproviderLoading,
  setAllBillingProvider,
  setBillingProviderByFacility,
  setLoading,
} from "../store/reducers/billingprovider";
import { showError } from "../utils/index";

// POST
const createBillingProvider = async (data, callback) => {
  try {
    store.dispatch(setAddbillingproviderLoading(true));
    let response = await https().post("billingprovider", data);

    if (response?.status === 200) {
      getBillingProviderByFacilitId(data?.facilityId);
      // getReports(false);
      callback?.();
    }

    return response;
  } catch (error) {
    store.dispatch(setAddbillingproviderLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const AddBillingProviderEnrollment = async (data, callback) => {
  try {
    store.dispatch(setAddbillingproviderLoading(true));
    let response = await https().post("billingprovider/providerenrollment", data);

    if (response?.status === 200) {
      // getReports(false);
      callback?.();
    }

    return response;
  } catch (error) {
    store.dispatch(setAddbillingproviderLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const getBillingProvider = async (payload, showLoading = true) => {
  try {
    if (showLoading) store.dispatch(setLoading(true));

    let response = await https().get(
      `billingprovider/${payload && payload.page ? `${payload.page}` : "all"}${
        payload && payload.name ? `?name=${payload.name}` : ""
      }`
    );

    if (response?.status === 200) {
      store.dispatch(setAllBillingProvider(response?.data));
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const getBillingProviderByFacilitId = async (
  data,
  page,
  showLoading = true
) => {
  try {
    if (showLoading) store.dispatch(setLoading(true));

    let response = await https().get(
      `billingprovider/billing-provider-by-facility-id/${data}?page=${page}`
    );

    if (response?.status === 200) {
      store.dispatch(setBillingProviderByFacility(response?.data));
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const editProvider = async (data, showLoading = true) => {
  try {
    store.dispatch(setLoading(true));
    let response = await https().put(`/billingprovider/${data?.id}`, data);

    if (response?.status === 200) {
      getBillingProvider(showLoading);
    }

    return response;
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const removeProvider = async (data, showLoading = true) => {
  try {
    store.dispatch(setLoading(true));

    console.log('data',data);

    let response = await https().delete(`/billingprovider/${data?.id}`);

    if (response?.status === 200) {
      getBillingProviderByFacilitId(data?.returnedFacility, 1, showLoading);
    }

    return response;
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

export {
  createBillingProvider,
  getBillingProvider,
  getBillingProviderByFacilitId,
  editProvider,
  removeProvider,
  AddBillingProviderEnrollment
};
